import { computed, Injectable, signal } from '@angular/core';
import { UserSettings } from '@app/core/models/payment/user-settings.interface';

@Injectable({
  providedIn: 'root'
})
export class ProviderLatestConfigService {
  private settings = signal<UserSettings | null>(null);

  settingsSignal = computed(() => {
    return this.settings();
  });

  plusSettingsSignal = computed(() => {
    return this.settingsSignal()?.plusSettings!;
  });

  connectSettingsSignal = computed(() => {
    return this.settingsSignal()?.connectSettings!;
  });

  bnplSettingsSignal = computed(() => {
    return this.settingsSignal()?.bnplSettings!;
  });

  capsPaySettingsSignal = computed(() => {
    return this.settingsSignal()?.capsPaySettings!;
  });

  generalSettingsSignal = computed(() => {
    return this.settingsSignal()?.generalSettings!;
  });

  constructor() {}

  setLatestConfig(config: UserSettings): void {
    this.settings.set(config);
  }
}
